import { Input } from "antd";
import { useState } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { tabsTypes } from "../../../conig";
import { Style } from '../../additional-subjects/table';
import List from "./list";

export default function Table({
  value = [],
  t = (s) => s,
  section = tabsTypes.MONITORING,
  onChange,
  data = [],
  hasInfoShared = true,
}) {
  const [search, setSearch] = useState('');

  return (
    <Style>
      {!data.length ? (
        <div className="table-cont no-data flex-c all">
          <div className="flex-c jus-c flex-1 main-c">
            <div className="icon flex-c jus-c">
              <SearchOutlined />
            </div>
            <h2>
              {t('No Source found')}
            </h2>
          </div>
        </div>
      ) : (
        <div className="table-cont">
          <Input
            prefix={<SearchOutlined />}
            value={search}
            placeholder={t('Search')}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            className="custom-input"
          />
          <List
            items={data}
            hasInfoShared={hasInfoShared}
            value={value}
            search={search}
            onChange={(v) => {
              onChange(`${section}InformationSources`, v);
            }}
          />
        </div>
      )}
    </Style>
  );
}

